import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate } from '@angular/router';
import { MenusComponent } from './components/menus/menus.component';
import { AccueilComponent } from './components/accueil/accueil.component';
import { SeConnecterComponent } from './components/se-connecter/se-connecter.component';
import { SInscrireComponent } from './components/s-inscrire/s-inscrire.component';
import { RecupererMdpComponent } from './components/recuperer-mdp/recuperer-mdp.component';
import { ActivitesComponent } from './components/activites/activites.component';
import { ProfilComponent } from './components/profil/profil.component';
import { ClassesComponent } from './components/classes/classes.component';
import { ClasseComponent } from './components/classe/classe.component';
import { JeuxComponent } from './components/jeux/jeux.component';
import { MenuAdminComponent } from './components/menu-admin/menu-admin.component';
import { EvenementsComponent } from './components/evenements/evenements.component';
import { ListeComponent } from './components/liste/liste.component';
import { ParticipantsComponent } from './components/participants/participants.component';
import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { RoleGuardService as RoleGuard } from './services/role-guard.service';

const routes: Routes = [
  { path: '', redirectTo : '/se_connecter', pathMatch: 'full'},
  { path: 'recuperer_mdp', component: RecupererMdpComponent },
  { path: 'accueil', children: [
    { path: '', component: AccueilComponent},
    { path: 'profil', component: ProfilComponent }
  ], canActivate: [AuthGuard] },
  { path: 'activites', children: [
      { path: '', component: ActivitesComponent},
      { path: 'jeux/:activityId_color', component: JeuxComponent }
    ] 
  },
  { path: 'admin', children: [
    {path: '', component: ParticipantsComponent},
    {path: 'evenements', children: [
      {path: 'creer', component: EvenementsComponent},
      {path: 'liste', component: ListeComponent}
    ]}
  ], canActivate: [RoleGuard] },
  { path: 'classes', component: ClasseComponent, canActivate: [AuthGuard] },
  { path: 'classe/:cdc', component: ClasseComponent, canActivate: [AuthGuard] },
  { path: 's_inscrire', component: SInscrireComponent },
  { path: 'se_connecter', component: SeConnecterComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routingComponents = [
  AccueilComponent,
  MenusComponent,
  MenuAdminComponent,
  SeConnecterComponent,
  SInscrireComponent,
  ListeComponent,
  RecupererMdpComponent,
  EvenementsComponent,
  ParticipantsComponent,
  ActivitesComponent,
  ProfilComponent,
  ClassesComponent,
  ClasseComponent,
  JeuxComponent
 ];

